<template>
  <!-- 待完成 -->
  <div class="phone_solution_box">
    <!-- 标题 -->
    <div class="solution_title">產業解決方案</div>
    <!-- 内容 -->
    <div class="solution_content_box">
      <!-- 輪播圖 -->
      <el-carousel :autoplay="false" arrow="always" type="card" height="40vw" indicator-position="none">
        <!-- 1 -->
        <el-carousel-item>

           <img src="../../../assets/img/index/tyg_solution1.png" alt="" @click="FunSolution1()">
           <!-- 內容： -->
           <div v-show="solutionTF1">
             <p>
               台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
             </p>
             <span @click="FunSolution1()">關閉</span>
           </div>

        </el-carousel-item>
        <!-- 2 -->
        <el-carousel-item>

          <img src="../../../assets/img/index/tyg_solution2.png" alt="" @click="FunSolution2()">
           <!-- 內容： -->
           <div v-show="solutionTF2">
             <p>
               台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
             </p>
             <span @click="FunSolution2()">關閉</span>
           </div>

        </el-carousel-item>
        <!-- 3 -->
        <el-carousel-item>

          <img src="../../../assets/img/index/tyg_solution3.png" alt="" @click="FunSolution3()">
           <!-- 內容： -->
           <div v-show="solutionTF3">
             <p>
               台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
             </p>
             <span @click="FunSolution3()">關閉</span>
           </div>

        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 分割线 -->
    <div class="cut_off"></div>
  <!--  -->
  </div>
</template>

<script>

export default {
  name: 'PhoneSolution',
  props: {

  },
  data() {
    return {
      solutionTF1: false,
      solutionTF2: false,
      solutionTF3: false,
    }
  },
  methods: {
    // 隱藏/顯示
    FunSolution1(){
      this.solutionTF1 = !this.solutionTF1;
    },
    FunSolution2(){
      this.solutionTF2 = !this.solutionTF2;
    },
    FunSolution3(){
      this.solutionTF3 = !this.solutionTF3;
    },
  },
  created(){
    
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.phone_solution_box {
  overflow: hidden;
  display: block;
}
.solution_title {
  font-size: 8vw;
  margin: 7.2vw 0;
  font-weight: bold;
  color: black;
  text-align: center;
}
  /* 輪播圖 */
  .el-carousel__item {
    /* position: relative; */
  }
  .el-carousel__item >img {
    width: 100%;
    height: 100%;
  }
  .el-carousel__item >div {
    color: white;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    font-size: 2.4vw;
    background: rgba(0, 0, 0, .8);
    padding: 0 2vw;
    line-height: 3.7vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
  .el-carousel__item >div >span {
    box-sizing: border-box;
    padding: 1vw 3.2vw;
    border: 1px solid white;
    border-radius: 3vw;
    margin-top: 1vw;
  }
  .cut_off {
    margin-top: 6vw;
    height: 2px;
    background: #e8e8e8;
  }
  


    /* 768px */
@media screen and (min-width:769px){
  /* 显示/隐藏 */
  .phone_solution_box {
    display: none;
  }
}
</style>
